import React from 'react';
import FormField from './FormField';
import { Dropdown } from 'react-native-element-dropdown';
import { View, StyleSheet } from 'react-native';
import FormnStyle from 'styles/Form';
import { useTheme } from '@rneui/themed';

const styles = StyleSheet.create({
  container: {
    backgroundColor: 'white',
    padding: 16,
  },
});

interface Props {
  value: string;
  title: string;
  placeholder: string;
  setFieldValue: any;
  setFieldTouched: any;
  selectItems: object[];
  style: any;
  setOtherFieldValues: any;
  disabled: boolean;
}

const Select: React.FC<Props> = ({
  value,
  title: _title,
  placeholder,
  setFieldValue,
  setFieldTouched: _setFieldTouched,
  selectItems,
  style,
  setOtherFieldValues,
  disabled,
}: Props) => {
  const { theme } = useTheme();

  const [isFocus, setIsFocus] = React.useState(false);

  const convertSelectItems = (
    items: any[]
  ): Array<{ label: string; value: string }> => {
    return items.map((item: any) => {
      return { label: item, value: item };
    });
  };

  return (
    <View style={style.container}>
      <Dropdown
        style={[
          FormnStyle.dropdown,
          { borderColor: theme.colors.primary },
          isFocus && { borderColor: theme.colors.primary },
          disabled && {
            borderColor: 'gray',
            backgroundColor: 'lightgray',
          },
        ]}
        placeholderStyle={FormnStyle.placeholderStyle}
        selectedTextStyle={FormnStyle.selectedTextStyle}
        inputSearchStyle={FormnStyle.inputSearchStyle}
        iconStyle={FormnStyle.iconStyle}
        data={convertSelectItems(selectItems)}
        maxHeight={300}
        labelField="label"
        valueField="value"
        placeholder={placeholder}
        value={value}
        onFocus={() => {
          setIsFocus(true);
        }}
        onBlur={() => {
          setIsFocus(false);
        }}
        onChange={(item) => {
          setFieldValue(item.value);
          setOtherFieldValues();
          setIsFocus(false);
        }}
        disable={disabled}
      />
    </View>
  );
};

Select.defaultProps = {
  value: '',
  style: styles,
  disabled: false,
};

export default FormField(Select);
